
// import store from '@/app/store'
// export const urls.API_URL = store.getters["backendUrl"]

export default {

    loginUrl: "/login.action",
    checkLoginUrl: "/checkLogin.action",
    logoutActionUrl: "/logout.action",

    /* project version */
    reloadProjectVersionUrl: "/reloadProjectVersion.action",

    /* GDPR information */
    getGDPRInfoUrl: "/showGDPR.action",

    /* user properties and header */
    reloadHeaderUrl: "/reloadHeader.action",
    userPropertiesUrl: "/userProperties.action",
    switchLocaleUrl: "/switchLocale.action",
    myPreferencesUrl: "/myPreferences.action",
    getUserInfoUrl: "/getUserInfo.action",
    getMailInfoUrl: "/getMailInfo.action",
    updateUserInfoUrl: "/updateUserInfo.action",
    updateUserPasswordUrl: "/updateUserPassword.action",
    recoverPwdUrl: "/recoverPwd.action",

    /* projects, profiles, quests */
    openProjectUrl: "/selectProject.action",
    selectProfileUrl: "/selectProfile.action",
    selectQuestUrl: "/selectQuest.action",

    onHomeLinkClickedUrl: "/onHomeLinkClicked.action",

    customSolutionsActionUrl: "/customSolutions.action",
    customSolutionsNavigateActionUrl: "/customSolutionsNavigate.action",

    /* searches */
    runBrowseCasebaseUrl: "/runBrowseCasebase.action",
    browseCasebaseByUrl: "/browseCasebaseBy.action",

    searchInitializeUrl: "/searchInitialize.action",
    initSearchInitializeUrl: "/initSearchInitialize.action",
    initSearchFilterUrl: "/initSearchFilter.action",

    freeTextSearchUrl: "/freeTextSearch.action",
    searchResultsNavigate: "/searchResultsNavigate.action",
    continueSearchUrl: "/continueSearch.action",
    textSearchHelpMessageUrl: "/ftqHelp.action",

    guidedSearchInitUrl: "/guidedSearchInit.action",
    guidedQuestionsUrl: "/guidedQuestions.action",
    guidedSearchUrl: "/guidedSearch.action",
    guidedToogleShowMoreLess: "/guidedToogleShowMoreLess.action",
    dialogToogleShowMoreLess: "/dialogToogleShowMoreLess.action",
    resetSearchUrl: "/resetSearch.action",

    expertSearchUrl: "/expertSearch.action",
    askExpertUrl: "/askExpert.action",
    expertSearchSolutionsUrl: "/expertSearchSolutions.action?transition=Search",

    expertSwitchToGuideUrl: "/expertSearchSolutions.action?transition=SwitchToGuide",
    getExpertViewAttributesUrl: "/getExpertViewAttributes.action",
    getGivenAttributeUrl: "/getGivenAttribute.action",

    querySummaryUrl: "/querySummary.action",
    searchResultsUrl: "/searchResults.action",

    searchCaseNameUrl: "/searchCaseName.action",

    /* breadcrumb */
    removeBreadCrumbUrl: "/removeBreadCrumb.action",
    updateBreadCrumbUrl: "/updateBreadCrumb.action",
    editBreadCrumbUrl: "/editBreadCrumb.action",

    /* casebases */
    caseBaseSearchUrl: "/caseBaseSearch.action",
    browseUrl: "/browse.action",
    caseBaseSearchQDetailsUrl: "/caseBaseSearchQDetails.action?id=",

    /* case-details */
    viewCaseDetailsUrl: "/viewCaseDetails.action",
    mailCaseUrl: "/mailCase.action",
    // mailPreviewCaseUrl: "/mailPreviewCase.action",  not supported in 6.0
    caseDetailsNavigateUrl: "/caseDetailsNavigate.action",
    caseCompareUrl: "/caseCompare.action",
    viewCasesForComparisonUrl: "/viewCasesForComparison.action",
    loadCasesForComparisonUrl: "/loadCasesForComparison.action",
    returnFromCompareUrl: "/returnFromCompare.action",
    returnFromCaseDetailsUrl: "/returnFromCaseDetails.action",
    solutionAcceptedUrl: "/solutionAccepted.action",
    printSolutionsUrl: "/printSolutions.action",
    generatePdfUrl: "/generatePdf.action",

    /* case versions */
    viewVersionsUrl: "/viewVersions.action",
    loadVersionsUrl: "/loadVersions.action",
    versionsUrl: "/versions.action",
    versionsTabsUrl: "/versionsTabs.action",
    selectVersionUrl: "/selectVersion.action",
    deleteVersionUrl: "/deleteVersion.action",
    restoreVersionUrl: "/restoreVersion.action",

    /* authoring */
    authoringUrl: "/authoring.action",
    authoringMCMUrl: "/authoringMCM.action",
    createNewFromSearchUrl: "/createNewFromSearch.action",
    createNewFromSolutionUrl: "/createNewFromSolution.action",
    manageSolutionsUrl: "/manageSolutions.action?cSR=",
    modifyExistingCaseUrl: "/modifyExistingCase.action",
    translateCaseUrl: "/translateCase.action",
    updateCaseUrl: "/updateCase.action",
    validateUpdateCaseUrl: "/validateUpdateCase.action",
    deleteCaseUrl: "/deleteCase.action",
    updateGivenAttribUrl: "/updateGivenAttribute.action",
    autoTagUrl: "/autoTag.action",
    acceptAutoTagUrl: "/acceptAutoTag.action",
    closeAutoTagurl: "/closeAutoTag.action",
    deleteAutoTagurl: "/deleteAutoTag.action",
    updatedCaseUrl: "/getUpdatedCase.action",

    /* auto save (KAI-12690) */
    restoreExistingCaseUrl: "/restoreDraftValuesForExistingCase.action",
    restoreNewCaseUrl: "/restoreDraftValuesForNewCase.action",
    discardDraftCaseUrl: "/discardDraftCase.action",
    deleteDraftCaseUrl: "/deleteDraftCase.action",
    getAllDraftsCasesUrl: "/getDraftCases.action",
    viewDraftsUrl: "/viewDrafts.action",
    loadDraftsUrl: "/loadDrafts.action",
    authoringServerPingUrl: "/authoringServerPing.action",

    /* mass authoring */
    getGivenViewAttributesUrl: "/getGivenViewAttributes.action",
    getGivenViewAttributesMCMUrl: "/getGivenViewAttributesMCM.action",
    getAttribValueSetMCMUrl: "/getAttribValueSetMCM.action",
    getAttributesValueSetMCMUrl: "/getAttributesValueSetMCM.action?viewId=",
    modifyExistingCasesMCMUrl: "/modifyExistingCasesMCM.action",
    updateGivenAttribMCMUrl: "/updateGivenAttributeMCM.action",
    authoringMCM: "/authoringMCM.action",
    updateMultipleCasesUrl: "/updateMultipleCases.action",
    validateMultipleCasesUrl: "/validateMultipleCases.action",
    deleteMultipleCasesUrl: "/deleteMultipleCases.action",


    /* favorites and recent solutions */
    addToFavoritesUrl: "/addToFavorites.action",
    removeFromFavoritesUrl: "/removeFromFavorites.action",
    getFavoritesUrl: "/getFavorites.action",
    showRecentlyViewedSolUrl: "/showRecentlyViewedSol.action",


    feedbackUrl: "/feedback.action",
    deleteComment: "/deleteComment.action",
    printCaseUrl: "/printCase.action?caseId=",
    defaultUserImage: "/themes/images/default-user.gif",


    restoreStateUrl: "/restoreState.action",
    getSolutionsForApprovalUrl: "/getSolutionsForApproval.action?questToSwitch=",
    getFilteredSolutionsForApprovalUrl: "/getFilteredSolutionsForApproval.action?",
    getSavedSessionsUrl: "/getSavedSessions.action",
    getSuggestedQuestionUrl: "/getSuggestedQuestion.action?suggestMode=",
    selectUndecidedValueUrl: "/selectUndecidedValue.action",
    selectUndecidedAttributeUrl: "/selectUndecidedAttribute.action?selectedValue=",
    skipUndecidedUrl: "/skipUndecided.action",
    getSearchSummaryUrl: "/getSearchSummary.action",
    submitFeedbackUrl: "/submitFeedback.action?isSolutionSolveYourProblem=",
    markCaseIdsAsSolutionsFoundUrl: "/markCaseIdsAsSolutionsFound.action?solutionFoundCaseIds=",

    // Not in use since 6.0, was used for TableHandler.showAuthorDetails
    // viewAllCasesUrl: "/viewAllCases.action?caseUserName=",
    // getAllCasesCountUrl: "/getAllCasesCount.action?caseUserName=",
    saveUserSessionUrl: "/saveUserSession.action?sessionName=",
    restoreSessionUrl: "/restoreSession.action?sesIdToRestore=",
    deleteSessionUrl: "/deleteSavedSession.action?sesIdsToDelte=",
    getStatusListUrl: "/getStatusList.action",
    deleteExistingCasesUrl: "/deleteExistingCases.action",
    resetAttribValueSetUrl: "/resetAttribValueSet.action?viewId=",
    getAttribValueSetUrl: "/getAttribValueSet.action?",
    getAttributesValueSetUrl: "/getAttributesValueSet.action",
    previousUrl: "/back.action",
    backToDifferentProjectUrl: "/backToDifferentProject.action",
    backFromDetailsUrl: "/backFromDetails.action",
    getSolutionsToPrintUrl: "/getSolutionsToPrint.action",
    crmFormFeedbackUrl: "/crmFormFeedback.action",
    crmListFeedbackUrl: "/crmListFeedback.action",

    /* fieldservice */
    myDSIDsDefaultUrl: "/DSDashboard.action?action=search",
    myWorkGroupsDefaultUrl: "/DSDashboard.action",
    allWorkGroupsDefaulUrl: "/DSDashboard.action?action=search",
    dsSearchUrl: "/DSDashboard.action?action=search",
    attAutocompleteUrl: "/ATTAutoComplete.action?att=APPLIANCE_MODEL",
    addDSIDUrl: "/DSDashboard.action?action=add",
    dsDashBoardInitUrl: "/DSDashboard.action?action=init",
    dsDashBoardWorkgroupsListUrl: "/DSDashboard.action?action=workgroup",
    dsHistoryInitUrl: "/DSHistory.action?action=init",
    initAddDSUrl: "/DSDashboard.action?action=add_init",
    startDSSelectionForSyncUrl: "/DSDashboard.action?action=start_ds_selection",
    updateDSSelectionForSyncUrl: "/DSDashboard.action?action=update_ds_selection",
    cancelDSSelectionForSyncUrl: "/DSDashboard.action?action=cancel_ds_selection",
    startDsSyncUrl: "/DSDashboard.action?action=start_synchronization",
    initCloseDSUrl: "/DSInitClose.action",
    dsDetailsUrl: "/DSDetails.action",
    dsDetailsAddNoteUrl: "/DSDetails.action?action=add_note",
    dsDetailsAddAttachmentsUrl: "/DSDetails.action?action=add_attachments",
    dsContinueUrl: "/DSDetails.action?action=continue",
    dsDetailstEditUrl: "/DSDetailsExit.action",
    addSearchUrl: "/DSAdd.action",
    continueUrl: "/DSContinue.action",
    viewReadOnlyUrl: "/DSViewReadOnly.action",
    searchUrl: "/DSSearch.action",
    exitUrl: "/DSExit.action",
    closeUrl: "/DSClose.action",
    dsCrmFeedback: "/DSCrmFeedback.action",
    dsSetStatusUrl: "/DSDetails.action?action=set_status",
    dsHistoryUrl: "/DSHistory.action",
    dsHistorySearchUrl: "/DSHistory.action?action=search",
    dsHistoryDefaultUrl: "/DSHistory.action",
    dsDetailsAttachmentUrl: "/DSDownloadAttachment.action",
    getApplicationPreservationUrl: "/MemoryFeature.action",
    setApplicationPreservationUrl: "/memoryUpdateFeature.action",
    campaignUrl: "/Campaign.action",
    trpUrl: "/TRP.action",
    wdUrl: "/WD.action",
    dsEscalateUrl: "/DSEscalate.action",
    selDSIDsDefaulUrl: "/DSDashboard.action?action=search&filtername=DS&filtervalue=&showselected=true",
    dsDetailsCloseUrl: "/DSDetails.action?action=init_close",
    dsGetEscalateUrl: "/DSGetEscalate.action",
    dsPrintEscalateUrl: "/DSPrintEscalate.action",
    exitShowcaseUrl: "/exitShowcase.action",
    callcenterUrl: "/CallCenter.action",
    federatedSearchUrl: "/FederatedSearch.action",
    hideResourceUrl: "/hideResource.action",
    resetResourceUrl: "/resetResource.action",
    generateBookmarkUrl: "/generateBookmark.action",
    executeBookmarkUrl: "/executeBookmark.action",
    selectResultUrl: "/selectResult.action",
    deselectResultUrl: "/deselectResult.action",
    selectAllResultsUrl: "/selectAllResults.action",
    deselectAllResultsUrl: "/deselectAllResults.action",
    newProjectRevisionUrl: "/newProjectRevision.action?backgroundcall=true",
    clientSideLoggerUrl: "/clientSideLogger.action",
    clientSideErrorLoggerUrl: "/clientSideErrorLogger.action",
    restoreActionUrl: "/restore.action",
    getNotificationsUrl: "/displayNotification.action",
    getNotificationsCloseUrl: "/closeNotification.action",
    openFileUrl: "/openFile.action",
    showcaseUrl: "/showcase.action",
    spellCheckUrl: "/spellCheck.action",
    pingUrl: "/ping.action",
    getCreateApprovalsUrl: "/getCreateApprovals.action",
    getUpdateApprovalsUrl: "/getUpdateApprovals.action",
    isDsDisabledForProfile: "isDsDisabledForProfile.action",
    closeCurrentDiagnosticSessionUrl: "/closeCurrentDiagnosticSession.action",
    dsDownloadAttachmentUrl: "/DSDownloadAttachment.action",
    dsShowCaseUrl: "/executeShowCase.action",
    dsUnlockUrl: "/DSUnlock.action",


    // kmoffline generation and download
    generateKMOfflinePackageUrl: "/generateKMOfflinePackage.action",
    downloadKMOfflineUrl: "/downloadKMOffline.action",

    // configuration
    initStylesUrl: "/initStyles.action",
    loadStylesUrl: "/loadStyles.action",
    saveStylesUrl: "/saveStyles.action",

    // kmoffline
    soloRegistrationValidatePwdUrl: "/soloRegistrationValidatePwd.action",

    // replica
    replicaCheckConnectivityUrl: "/replicaCheckConnectivity.action",
    replicaCheckForUpdateUrl: "/replicaCheckForUpdate.action",
    replicaSynchronizeUrl: "/replicaSynchronize.action",

}